import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="container footer-content">
        <div className="footer-section">
          <h3>Zpost</h3>
          <p>The future of Free Speech.<br />Own your .zpost.eth identity.</p>
        </div>
        <div className="footer-section">
          <h3>Platform</h3>
          <ul>
            <li><Link to="/home" className="footer-link">Home</Link></li>
            <li><Link to="/explore" className="footer-link">Explore</Link></li>
            <li><Link to="/ens" className="footer-link">Get .zpost.eth</Link></li>
            <li><Link to="/wallet" className="footer-link">Wallet</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><Link to="/guide" className="footer-link">Guide</Link></li>
            <li><Link to="/about" className="footer-link">About Zpost</Link></li>
            <li><Link to="/blog" className="footer-link">Blog</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><Link to="/privacy-policy" className="footer-link">Privacy</Link></li>
            <li><Link to="/terms-of-service" className="footer-link">Terms</Link></li>
            <li><Link to="/cookie-policy" className="footer-link">Cookies</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        © 2026 Zpost. All rights reserved.
        <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
        <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
        {/* SIMPLE X button that will definitely work */}
        <a 
          href="https://x.com/intent/post?text=The%20future%20of%20Free%20Speech.%20Zpost:%20Posting%20powered%20by%20your%20self-sovereign%20.zpost.eth%20identity.%20Join%20the%20decentralized%20social%20revolution.&url=https://zpost.ai"
          className="share-x" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'linear-gradient(135deg, #111 0%, #000 100%)',
            color: '#FFD700',
            padding: '10px 20px',
            borderRadius: '30px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '1rem',
            border: '1px solid #FFD700',
            boxShadow: '0 4px 15px rgba(255, 215, 0, 0.2)',
            marginLeft: '20px',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'linear-gradient(135deg, #FFD700 0%, #DAA520 100%)';
            e.currentTarget.style.color = '#000000';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 215, 0, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'linear-gradient(135deg, #111 0%, #000 100%)';
            e.currentTarget.style.color = '#FFD700';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(255, 215, 0, 0.2)';
          }}
        >
          Share to 
          <span style={{
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: 'inherit'
          }}>
            𝕏
          </span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
